export default __webpack_public_path__ + "static/modal1-c7d160d14b1eacb14728ca01a636c8db.png";